<template>
  <div>
    <a-modal
      :title="'查看批次商品库存流水【批号：' + currentBatchNumber + '】'"
      :width="1000"
      :visible="visible"
      :confirmLoading="false"
      :footer="null"
      :maskClosable="false"
      :zIndex="900"
      :bodyStyle="{height: '500px', overflowY: 'auto'}"
      @cancel="handleCancel"
      style="top:50px;">
      <a-spin :spinning="loading">
        <!-- 查询区 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入单据编号" v-model="queryParam.number"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam.dateRange"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                    @change="onDateChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download">导出</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 表格 -->
        <a-table
          bordered
          ref="table"
          size="middle"
          rowKey="id"
          :columns="flowColumns"
          :dataSource="flowDataSource"
          :pagination="false"
          :scroll="{ x: true }"
          :loading="loading"
          @change="handleFlowTableChange">
          <span slot="numberCustomRender" slot-scope="text, record">
            <a @click="handleNumberClick(record)">{{ record.number }}</a>
          </span>
        </a-table>
        <a-row :gutter="24" style="margin-top: 8px; textAlign: right">
          <a-col :md="24" :sm="24">
            <a-pagination
              @change="flowPaginationChange"
              @showSizeChange="flowPaginationShowSizeChange"
              size="small"
              show-size-changer
              show-quick-jumper
              :current="flowPagination.current"
              :page-size="flowPagination.pageSize"
              :page-size-options="flowPagination.pageSizeOptions"
              :total="flowPagination.total"
            />
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
    <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
  </div>
</template>

<script>
import { getAction, downFilePost } from '@/api/manage'
import moment from 'moment'
import BillDetail from '@/views/bill/dialog/BillDetail'

export default {
  name: 'BatchStockFlowModal',
  components: {
    BillDetail
  },
  data() {
    return {
      visible: false,
      loading: false,
      currentBatchNumber: '',
      currentMaterialId: null,
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      queryParam: {
        number: '',
        dateRange: [],
        beginTime: '',
        endTime: ''
      },
      flowColumns: [
        {
          title: '序号', dataIndex: 'rowIndex', width: 50, align: 'center',
          customRender: function(t, r, index) { return parseInt(index) + 1 }
        },
        {
          title: '单据编号', dataIndex: 'number', width: 160, ellipsis: true,
          scopedSlots: { customRender: 'numberCustomRender' }
        },
        { title: '类型', dataIndex: 'type', width: 100, ellipsis: true },
        { title: '条码', dataIndex: 'barCode', width: 120, ellipsis: true },
        { title: '名称', dataIndex: 'materialName', width: 150, ellipsis: true },
        { title: '仓库名称', dataIndex: 'depotName', width: 100, ellipsis: true },
        { title: '数量', dataIndex: 'basicNumber', width: 80, align: 'right' },
        { title: '日期', dataIndex: 'operTime', width: 160, ellipsis: true }
      ],
      flowDataSource: [],
      flowPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50'],
        total: 0
      }
    }
  },
  methods: {
    moment,
    show(record) {
      this.currentBatchNumber = record.batchNumber || ''
      this.currentMaterialId = record.materialId
      this.visible = true
      this.searchReset()
      this.loadFlowData()
    },
    handleCancel() {
      this.visible = false
    },
    onDateChange(value, dateString) {
      if (dateString && dateString.length === 2) {
        this.queryParam.beginTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      }
    },
    searchQuery() {
      this.flowPagination.current = 1
      this.loadFlowData()
    },
    searchReset() {
      this.queryParam = {
        number: '',
        dateRange: [],
        beginTime: '',
        endTime: ''
      }
      this.flowPagination.current = 1
    },
    loadFlowData() {
      this.loading = true
      const params = {
        batchNumber: this.currentBatchNumber,
        materialId: this.currentMaterialId,
        number: this.queryParam.number || undefined,
        beginTime: this.queryParam.beginTime || undefined,
        endTime: this.queryParam.endTime || undefined,
        column: 'createTime',
        order: 'desc',
        field: 'id,,,number,type,barCode,materialName,depotName,basicNumber,operTime',
        currentPage: this.flowPagination.current,
        pageSize: this.flowPagination.pageSize
      }
      getAction('/depotItem/findDetailByDepotIdsAndMaterialId', params).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.flowDataSource = res.data.rows || []
          this.flowPagination.total = res.data.total || 0
        } else {
          this.flowDataSource = []
          this.flowPagination.total = 0
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    handleFlowTableChange(pagination) {
      if (pagination) {
        this.flowPagination.current = pagination.current
        this.flowPagination.pageSize = pagination.pageSize
      }
      this.loadFlowData()
    },
    flowPaginationChange(current, pageSize) {
      this.flowPagination.current = current
      this.flowPagination.pageSize = pageSize
      this.loadFlowData()
    },
    flowPaginationShowSizeChange(current, pageSize) {
      this.flowPagination.current = 1
      this.flowPagination.pageSize = pageSize
      this.loadFlowData()
    },
    handleNumberClick(record) {
      if (!record.number) return
      const { type, prefixNo } = this.getBillTypeByNumber(record.number)
      if (!type) return
      this.$refs.modalDetail.isCanBackCheck = false
      this.$refs.modalDetail.show(record, type, prefixNo)
      this.$refs.modalDetail.title = type + '-详情'
    },
    getBillTypeByNumber(number) {
      if (!number) return { type: '', prefixNo: '' }
      if (number.indexOf('QTRK') > -1) return { type: '其它入库', prefixNo: 'QTRK' }
      if (number.indexOf('QTCK') > -1) return { type: '其它出库', prefixNo: 'QTCK' }
      if (number.indexOf('CGRK') > -1) return { type: '采购入库', prefixNo: 'CGRK' }
      if (number.indexOf('CGTH') > -1) return { type: '采购退货出库', prefixNo: 'CGTH' }
      if (number.indexOf('XSCK') > -1) return { type: '销售出库', prefixNo: 'XSCK' }
      if (number.indexOf('XSTH') > -1) return { type: '销售退货入库', prefixNo: 'XSTH' }
      if (number.indexOf('LSCK') > -1) return { type: '零售出库', prefixNo: 'LSCK' }
      if (number.indexOf('LSTH') > -1) return { type: '零售退货入库', prefixNo: 'LSTH' }
      return { type: '', prefixNo: '' }
    },
    modalFormOk() {
      // 单据详情弹窗关闭后的回调
    },
    modalFormClose() {
      // 单据详情弹窗关闭后的回调
    },
    exportExcel() {
      const list = []
      const head = '单据编号,类型,条码,名称,仓库名称,数量,日期'
      const flowData = this.flowDataSource
      for (let i = 0; i < flowData.length; i++) {
        const ds = flowData[i]
        list.push([
          ds.number || '', ds.type || '', ds.barCode || '',
          ds.materialName || '', ds.depotName || '',
          ds.basicNumber || 0, ds.operTime || ''
        ])
      }
      const tip = '批号=' + this.currentBatchNumber
      this.handleExportXlsPost('批次库存流水', '批次库存流水', head, tip, list)
    },
    handleExportXlsPost(fileName, title, head, tip, list) {
      if (!fileName || typeof fileName !== 'string') {
        fileName = '导出文件'
      }
      let paramObj = { title, head, tip, list }
      downFilePost(paramObj).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败')
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
      })
    }
  }
}
</script>